export { default } from "./DynamicallyConfiguredInsightMenu";
